export default __webpack_public_path__ + "static/media/Banner_2.1e612e24.webp";